export const TOKEN = 'TOKEN';
export const USER = 'USER';
export const MASTER_CONTRACTS_LOCAL = 'quantiply-admin-panel-contracts-local';
export const MASTER_CONTRACTS_LOT_SIZES =
  'quantiply-admin-panel-contracts-lot-sizes';
export const THEME = 'THEME';
export const PREV_PAGE = 'PREV_PAGE';
